export const iOSDevice = () => navigator.platform.match(/iPhone|iPod|iPad/u);

export const DESKTOP_MIN_WIDTH = 1200;

export const DESKTOP_LARGE_MIN_WIDTH = 1700;

export const isDesktopMedia = () => window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`).matches;

export const isNewDesktopMedia = () => isDesktopMedia();

export const desktopLargeMedia = () => window.matchMedia(`(min-width: ${DESKTOP_LARGE_MIN_WIDTH}px)`);

export const isDesktopLargeMedia = () => desktopLargeMedia().matches;

export const isDesktopSmallMedia = () => window.matchMedia('(min-width: 481px)').matches;

export const isDesktop = () => isDesktopMedia();

export const isNewDesktop = () => isNewDesktopMedia();

export const isDesktopLarge = () => isDesktopLargeMedia();

export const isDesktopSmall = () => isDesktopSmallMedia();
